import styles from "@components/v1/Video.module.css";

type VideoProps = React.DetailedHTMLProps<React.VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement>;

type Props = Pick<VideoProps, "onPlay" | "poster"> & {
  videoUrl: string;
};

const Video = ({ videoUrl, ...videoProps }: Props) => (
  // eslint-disable-next-line jsx-a11y/media-has-caption
  <video {...videoProps} className={styles.video} controls height="100%" width="100%">
    <source src={videoUrl} type="video/mp4" />
  </video>
);

export default Video;
